export const MODAL_DIALOG__CREATE_SITE_ALIAS = 'MODAL_DIALOG__CREATE_SITE_ALIAS';
